import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `movimientoVerraco/getOrigenMovimientoVerraco`, method: 'POST', body: values, token: token})
}